import EmblaCarousel from 'embla-carousel';
import StickyColumn from '../utils/sticky-column.js';

const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

export default class ProductDetails {
  constructor() {
    this.stickyColumns = [];
    this.setupStickyAccordions();
    document.querySelectorAll('[js-gallery-carousel]').forEach((el) => this.init(el));
  }

  setupStickyAccordions() {
    this.stickyColumns.forEach((stickyColumn) => stickyColumn.destroy());
    this.stickyColumns = [];

    document.querySelectorAll('.ird-product-details__accordions').forEach((el) => {
      const stickyColumn = new StickyColumn(el, { offset: 44, minWidth: 768 });
      this.stickyColumns.push(stickyColumn);

      el.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => {
          requestAnimationFrame(() => stickyColumn.refresh());
        });
      });
    });
  }

  init(el) {
    const viewport = el.querySelector('[js-gallery-carousel-viewport]');
    const dotsContainer = el.querySelector('[js-gallery-carousel-dots]');
    const slides = el.querySelectorAll('.ird-product-details__gallery-slide');

    if (!viewport || slides.length < 2) return;

    let embla = null;
    let dots = [];

    const buildDots = () => {
      dotsContainer.innerHTML = '';
      dots = [];
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.classList.add('ird-product-details__dot');
        if (i === 0) dot.classList.add('ird-product-details__dot--active');
        dot.addEventListener('click', () => embla?.scrollTo(i));
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });
    };

    const syncDots = () => {
      const index = embla.selectedScrollSnap();
      dots.forEach((d, i) => d.classList.toggle('ird-product-details__dot--active', i === index));
    };

    const initEmbla = () => {
      if (embla) return;
      embla = EmblaCarousel(viewport, { loop: false, align: 'start', dragFree: false });
      buildDots();
      embla.on('select', syncDots);
    };

    const destroyEmbla = () => {
      if (!embla) return;
      embla.destroy();
      embla = null;
      dotsContainer.innerHTML = '';
      dots = [];
    };

    if (MOBILE_MQ.matches) initEmbla();

    MOBILE_MQ.addEventListener('change', (e) => {
      if (e.matches) initEmbla();
      else destroyEmbla();
    });
  }
}
